import {Component, Input} from '@angular/core';

@Component({
  selector: 'loader',
  template: `
    <div>
      <ng-content></ng-content>
      <mat-spinner
        [diameter]="diameter"
        [style.margin]="margin"></mat-spinner>
    </div>`,
})
export class LoaderComponent {

  @Input() margin = 'auto';
  @Input() diameter = 60;
}
